import {AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';

export interface UserData {
  code: string;
  type_Reunion: string;
  period: string;
  source: string;
}

/** Constants used to fill up our data base. */
const SOURCE: string[] = [
  'test',
  'test',
  'test',
  'test',
  'test',
  'test',
  'test',
  'test',
];
const TYPE: string[] = [
  'Revue de direction',
  'Réunion hebdomadaire administratif',
  'brainstorming',
  'Revue documentaire',
  'Revue produit fini',
  'Réunion des superviseurs',
  'réunion marketing',
  'Réunion comité de direction ',

];
@Component({
  selector: 'app-reunion',
  templateUrl: './reunion.component.html',
  styleUrls: ['./reunion.component.scss']
})
export class ReunionComponent implements AfterViewInit  {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  displayedColumns: string[] = ['code', 'type_Reunion', 'period', 'source'];
  dataSource: MatTableDataSource<UserData>;

 
  dtOptions: any = {};
  constructor() {
    // Create 100 users
  const users = Array.from({length: 100}, (_, k) => this.createNewUser(k + 1));

    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource(users);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
    
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  createNewUser(code: number): UserData {
    const type =
      TYPE[Math.round(Math.random() * (TYPE.length - 1))] +
      ' ' +
      TYPE[Math.round(Math.random() * (TYPE.length - 1))].charAt(0) +
      '.';
  
    return {
      code: code.toString(),
      type_Reunion: type,
      period: Math.round(Math.random() * 100).toString(),
      source: SOURCE[Math.round(Math.random() * (SOURCE.length - 1))],
    };
  }

}